// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".I_RsnbGHO0B2pGKJUTNX {\n  color: #eb2f96 !important;\n}\n", "",{"version":3,"sources":["webpack://./../../common/components/icon/errorIcon.module.less"],"names":[],"mappings":"AAGA;EACE,yBAAA;AAFF","sourcesContent":["@import '../../../styles/common-variables';\n@import '../../../styles/antd-variables';\n\n.errorIcon {\n  color: @error-color !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorIcon": "I_RsnbGHO0B2pGKJUTNX"
};
export default ___CSS_LOADER_EXPORT___;
